import { render } from "./budget-item.vue?vue&type=template&id=21f87028&scoped=true"
import script from "./budget-item.js?vue&type=script&lang=js&external"
export * from "./budget-item.js?vue&type=script&lang=js&external"

import "./budget-item.scss?vue&type=style&index=0&id=21f87028&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f87028"]])

export default __exports__